const icon_minus = '<svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="0.5" x2="8" y2="0.5" stroke="black"/></svg>'
const icon_plus = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" fill="white"/><line x1="4" y1="8.5" x2="13" y2="8.5" stroke="black"/><line x1="8.5" y1="4" x2="8.5" y2="13" stroke="black"/></svg>'
const icon_delete = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="rotate_icon"><line x1="3.8101" y1="3.96822" x2="11.5883" y2="11.7464" stroke="black"/><line x1="11.5894" y1="3.81107" x2="3.81122" y2="11.5892" stroke="black"/></svg>'

// TO BE ACTIVATED ON PRODUCTION TO HIDE CONSOLE.LOG FROM FILTER APP
// const log = console.log.bind(console)
// console.log = (...args) => {
//   if ((args.indexOf('replaceState') != 0) && (args.indexOf('pushState') != 0)) {
//     log(...args)
//   }
// }

// keep tracking of number of samples in the cart
let samples_count = 0
let samples_list = []
let max_free_samples = 0
let lastScrollPosition = ''

// keep element reference to unbind click event after discount code is removed from
let discountListener = null

// Add a product to cart (and update the cart) using ajax
function addProduct (variant_id, handle, quantity, scrollUp, product_id, showPopup = false) {
  if (showPopup) {
    openFProductModal();
    return;
  }
  // addDCartScript()
  if (scrollUp) {
    scrollUpCart()
    $('.cart-content').addClass('cart-content--loading')
  }

  // check if the product has variant
  let tempVariant = document.getElementById(product_id)

  if (tempVariant) {
    tempVariant = tempVariant?.value;
    if (tempVariant !== '0' && tempVariant !== undefined) {
      if (tempVariant !== 'null') {
        variant_id = tempVariant
      } else {
        // show error
        $('#tooltip-' + product_id).css('visibility', 'visible')
        setTimeout(() => {
          $('#tooltip-' + product_id).css('visibility', 'hidden')
        }, 2000)
        return false
      }
    }
  }

  openAlert('Adding your item...')
  lastScrollPosition = document.documentElement.scrollTop || document.body.scrollTop

  // if (!$('#cart-right-side').hasClass('show')) {
  //   $('#cart-right-side').toggleClass('show')
  //   $('body').toggleClass('offcanvas-active')
  //   $('.screen-overlay').toggleClass('show')
  //   if (/iPhone/i.test(navigator.userAgent)) {
  //     setTimeout(() => {
  //       $('body').addClass('body-no-scroll')
  //       $('html').addClass('html-full-height')
  //       window.scrollTo(0, lastScrollPosition)
  //     }, 1000)
  //   }
  // }

  // check for selling plan
  let $sellingPlan = document.querySelector('input[name="selling_plan"]')
  let sellingPlan = null
  if ($sellingPlan) {
    sellingPlan = $sellingPlan.value
  }

  console.log($sellingPlan, sellingPlan)

  const addData = {
    'id': variant_id,
    'quantity': quantity,
    'selling_plan': sellingPlan
  }

  if (canAddIt(handle)) {
    let existedItems = [];
    let current_quantity = document.getElementById('quantity-screen');
    if (current_quantity) {
      current_quantity = current_quantity.innerHTML;
      current_quantity = parseFloat(current_quantity);
    } else {
      current_quantity = 1;
    }

    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      async: false,
      dataType: 'json',
      success: function (response){
        if (response.items) {
          response.items.forEach(item => {
            existedItems.push(item.id + '');
          });
        }
      }
    });

    if (current_quantity && existedItems.indexOf(String(variant_id)) > -1 && window.Rebuy.SmartCart) {
      if (current_quantity > 0) {
        const items = window.Rebuy.SmartCart.items();
        items.forEach((item) => {
          if (String(item.id) === String(variant_id)) {
            let oldQuantity = item.quantity;
            let quantity = parseInt(current_quantity) + parseInt(oldQuantity);
            window.Rebuy.Cart.setItemQuantity(item, quantity);
          }
        });
      }
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(addData)
      })
        .then((response) => {
          response.json()
            .then((result) => {
              if (response.status === 200) {
                // check if product exists in cart
                if (productExistsInCart(result.id)) {

                  let current_quantity = document.getElementById('quantity-' + result.id).innerHTML
                  current_quantity = parseFloat(current_quantity)

                  updateProductQuantities(result.id, result.quantity, handle, '')

                  // if we increase the quantity of a sample, update the counter
                  let aux_price = document.getElementById('price-' + result.id).innerHTML
                  aux_price = aux_price.replace('$', '')
                  aux_price = parseFloat(aux_price)

                  if (aux_price == 0) {
                    if (quantity > 0) {
                      samples_count++
                    } else {
                      samples_count--
                      samples_list = samples_list.filter(obj => obj !== result.id)
                      if (samples_count < 0) {
                        samples_count = 0
                      }
                    }
                  }
                } else {
                  // add product to dom
                  let $cart_drawer_content = $('#cart-drawer-content')

                  // $cart_drawer_content.append(generateProductElement(result, ''))
                  const foundPaidProducts = $cart_drawer_content.find('.cart-item:not(.free-sample)')
                  const lastProduct = foundPaidProducts.length ? foundPaidProducts[foundPaidProducts.length - 1] : null
                  if (lastProduct) lastProduct.after(generateProductElement(result, ''))
                  else $cart_drawer_content.append(generateProductElement(result, ''))
                }

                updateTotals()

                if (scrollUp) {
                  $('.cart-content').removeClass('cart-content--loading')
                }
              }
            })
            .catch((error) => {
              console.log('catch', error)
            })
        })
        .catch((error) => {
          console.log('catch', error)
        });
    }
  }
}

function openCartAfterMultipleAdd () {
  if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
    Rebuy.SmartCart.show()
    return
  }
   
  let cartDrawer = $('#cart-right-side')
  if (cartDrawer.length > 0 && !cartDrawer.hasClass('show')) {
    cartDrawer.toggleClass('show')
    $('body').toggleClass('offcanvas-active')
    $('.screen-overlay').toggleClass('show')

    if (/iPhone/i.test(navigator.userAgent)) {
      $('body').addClass('body-no-scroll')
      $('html').addClass('html-full-height')
    }
  }
}

// Add multiple products to cart in a single request and open cart at the end.
function addMultipleProducts (variant_ids, handles, quantities = 1, scrollUp = false, showPopup = false) {
  if (showPopup) {
    openFProductModal();
    return false
  }

  const parsedGlobalQuantity = parseInt(quantities, 10)

  let parsedVariantIds = Array.isArray(variant_ids)
    ? variant_ids
    : String(variant_ids || '').split(',')

  // Keep argument compatibility with existing callers and support CSV quantities per item.
  let parsedQuantities = Array.isArray(quantities)
    ? quantities
    : String(quantities || '').split(',')

  parsedVariantIds = parsedVariantIds.map((id) => String(id).trim()).filter((id) => id.length > 0)
  parsedQuantities = parsedQuantities.map((itemQuantity) => String(itemQuantity).trim())

  if (parsedVariantIds.length === 0) {
    return false
  }

  const items = []
  for (let i = 0; i < parsedVariantIds.length; i++) {
    const parsedId = parseInt(parsedVariantIds[i], 10)
    if (isNaN(parsedId)) {
      continue
    }

    let parsedQuantity = parseInt(parsedQuantities[i], 10)
    if (isNaN(parsedQuantity) || parsedQuantity < 1) {
      parsedQuantity = (!isNaN(parsedGlobalQuantity) && parsedGlobalQuantity > 0) ? parsedGlobalQuantity : 1
    }

    items.push({
      id: parsedId,
      quantity: parsedQuantity
    })
  }

  if (items.length === 0) {
    return false
  }

  if (scrollUp) {
    $('.cart-content').addClass('cart-content--loading')
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw errorData
        })
      }

      return response.json()
    })
    .then(() => {
      if (typeof getCartContent === 'function') {
        getCartContent()
      } else if (typeof updateTotals === 'function') {
        updateTotals()
      }

      openCartAfterMultipleAdd()

      if (scrollUp) {
        $('.cart-content').removeClass('cart-content--loading')
      }
    })
    .catch((error) => {
      console.log('catch', error)
      if (scrollUp) {
        $('.cart-content').removeClass('cart-content--loading')
      }
    })

  return true
}

// check if the product to add is a sample and it can be added
function canAddIt (handle) {
  let aux = $.ajax({
    type: 'GET',
    url: '/products/' + handle + '.js',
    cache: false,
    async: false,
    dataType: 'json'
  }).responseText

  if (IsJsonString(aux)) {
    aux = JSON.parse(aux)
    if (aux) {
      if (
        ((aux.price == 0) && ((samples_count + 1) <= max_free_samples)) ||
        (aux.price > 0)
      ) {
        return true
      }
    }
    return false
  } else {
    // openAlert('Please refresh the page')
  }
}

// check if product exists in cart
function productExistsInCart (id) {
  let aux = document.querySelectorAll('.cart-item')
  for (let i = 0; i < aux.length; i++) {
    if (aux[i].getAttribute('id') == id) {
      return true
    }
  }
  return false
}

// Add a bundle to the cart
function addBundleToCart (variant_id, products, quantity, bundle_handle) {
  lastScrollPosition = document.documentElement.scrollTop || document.body.scrollTop
  // addDCartScript()
  $('.cart-content').addClass('cart-content--loading')
  $('#message-empty-card').hide()

  if (!$('#cart-right-side').hasClass('show')) {
    $('#cart-right-side').toggleClass('show')
    $('body').toggleClass('offcanvas-active')
    $('.screen-overlay').toggleClass('show')
    if (/iPhone/i.test(navigator.userAgent)) {
      setTimeout(() => {
        $('body').addClass('body-no-scroll')
        $('html').addClass('html-full-height')
        window.scrollTo(0, lastScrollPosition)
      }, 1000)
    }
  }

  let aux = products.split(',')
  const products_in_bundle = aux.length

  // create original quantity for each product in bundle
  let originalQuantity = []

  aux.forEach(element => {
    if (element.length > 0) {
      let data = {
        'id': element,
        'quantity': 1
      }

      let temp = originalQuantity.findIndex(elem => elem.id == element)
      if (temp > -1) {
        originalQuantity[temp].quantity++
      } else {
        originalQuantity.push(data)
      }
    }
  })

  setTimeout(() => {
    aux.forEach(element => {
      if (element.length > 0) {
        let aux_bundle = getProductInfo(element)

        let aux_bundle_id = (aux_bundle.variants.length > 0) ? aux_bundle.variants[0].id : aux_bundle.variants[0].id

        let data = {
          'id': aux_bundle_id,
          'quantity': quantity,
          'properties': {
            '_bundle_id': variant_id,
            '_bundle': bundle_handle,
            '_compare_price': aux_bundle.compare_at_price,
            '_price': aux_bundle.price,
            '_quantity': products_in_bundle,
            '_original': JSON.stringify(originalQuantity)
          }
        }

        let aux = $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          cache: false,
          async: false,
          dataType: 'json',
          data: data
        }).responseText
      }
    })
    getCartContent()
  }, 200)

}

// Close filters menu onclick btn-close.
function closeFilters () {
  $('html').removeClass('offcanvas-open')
}

function updateFreeShippingProgress (total_price) {
  let free_shipping_progress_bar = document.getElementById('free_shipping_progress_bar');
  
  let framar_sticker_in_cents = document.getElementById('framar_sticker_in_cents').value
  let threshold_in_cents = document.getElementById('threshold_in_cents').value
  let framar_bag_in_cents = document.getElementById('framar_bag_in_cents').value
  
  framar_bag_in_cents = (framar_bag_in_cents.length > 0) ? framar_bag_in_cents * 1 : 0
  let progress_percentage = 0
  let aux_cart_shipping = document.getElementById('cart-shipping-free')

  var remain_text = $("#no_free_shipping_message");
  $(".rebuy-cart__progress-step-wrapper .rebuy-cart__progress-step").removeClass("complete");
  if(total_price <= framar_sticker_in_cents && freeProductEnable == true){
    var remain_amount = '$' + Math.abs(((total_price - framar_sticker_in_cents) / 100).toFixed(2));
    remain_text.html("You're "+remain_amount+" away from free Framar Sticker <span class='main-color'>*</span>");
  }
  if(total_price >= framar_sticker_in_cents && total_price <= threshold_in_cents){
    var remain_amount = '$' + Math.abs(((total_price - threshold_in_cents) / 100).toFixed(2));
    remain_text.html("You're "+remain_amount+" away from free shipping <span class='main-color'>*</span>");
    $(".rebuy-cart__progress-step-wrapper .rebuy-cart__progress-step:eq(0)").addClass("complete");
  }
  if(total_price >= threshold_in_cents && total_price <= framar_bag_in_cents && bagProductEnable == true){
    var remain_amount = '$' + Math.abs(((total_price - framar_bag_in_cents) / 100).toFixed(2));
    remain_text.html("You're "+remain_amount+" away from free Framar Bag <span class='main-color'>*</span>");
    $(".rebuy-cart__progress-step-wrapper .rebuy-cart__progress-step:eq(0)").addClass("complete");
    $(".rebuy-cart__progress-step-wrapper .rebuy-cart__progress-step:eq(1)").addClass("complete");
  }
  if(total_price >= progressCompleteTotal){
    $(".rebuy-cart__progress-step-wrapper .rebuy-cart__progress-step").addClass("complete");
  }
  
  // message hide/show in cart
  if (total_price >= progressCompleteTotal) {
    $('#free_shipping_message').show()
    $('#no_free_shipping_message').hide()
  } else {
    $('#free_shipping_message').hide()
    $('#no_free_shipping_message').show()
  }
  
  // display free shipping message in cart
  if (total_price >= threshold_in_cents) {
    aux_cart_shipping.innerHTML = 'FREE'
  } else {
    aux_cart_shipping.innerHTML = '--'
  }

  // calculate and display progress bar
  progress_percentage = (total_price * 100) / progressCompleteTotal
  if (progress_percentage > 100) { progress_percentage = 100 }
  free_shipping_progress_bar.style.setProperty('--progress-percentage', progress_percentage + '%')

  /*
  let amount_to_free = document.getElementById('shipping-max-amount')
  amount_to_free.innerHTML = '$' + Math.abs(((total_price - framar_bag_in_cents) / 100).toFixed(2))
  */
}

// render cart content
function getCartContent () {
  $('.cart-content').addClass('cart-content--loading')

  let cart_drawer_content = document.getElementById('cart-drawer-content')
  max_free_samplesElem = document.getElementById('max_free_samples');
  max_free_samples = 0;
  if (max_free_samplesElem && max_free_samplesElem.length) {
    max_free_samples = max_free_samplesElem.value;
    max_free_samples = max_free_samples * 1
  }

  fetch('/cart.js', {
    method: 'GET'
  })
    .then((response) => {
      response.json()
        .then((result) => {

          // update header cart count
          updateQuantityHeader(result.item_count)

          // update free shipping progress bar
          updateFreeShippingProgress(result.total_price)

          // display products
          // clear cart content
          cart_drawer_content.innerHTML = ''

          let products = result.items
          // sort products by price
          products.sort(function (a, b) {
            return b.price - a.price
          })
          let bundle_ids = []

          for (let i = 0; i < products.length; i++) {
            //check if the product is a bundle
            let aux_bundle_id = ''
            let aux_bundle_handle = ''
            let aux_bundle_quantity = 1
            let aux_bundle_quantity_unique = 1

            if (products[i].properties) {
              if (products[i].properties['_bundle_id']) {
                aux_bundle_id = products[i].properties['_bundle_id']
                aux_bundle_handle = products[i].properties['_bundle']
                aux_bundle_quantity = products[i]['quantity']
                aux_bundle_quantity_unique = products[i].properties['_quantity']
              }
            }
            // skip if its a bundle
            if (aux_bundle_id.length == 0) {
              let auxProductElement = generateProductElement(products[i], '')
              cart_drawer_content.appendChild(auxProductElement)
            } else {
              // get a list of uniques bundles ids
              let bundle_found = false
              for (let k = 0; k < bundle_ids.length; k++) {
                if (bundle_ids[k].bundle_id == aux_bundle_id) {
                  bundle_ids[k].quantity = bundle_ids[k].quantity + aux_bundle_quantity
                  bundle_found = true
                }
              }

              if (!bundle_found) {
                bundle_ids.push({
                  'bundle_id': aux_bundle_id,
                  'bundle_handle': aux_bundle_handle,
                  'quantity': aux_bundle_quantity,
                  'aux_bundle_quantity_unique': aux_bundle_quantity_unique
                })
              }
            }
          }

          // add bundles to cart
          if (bundle_ids.length > 0) {
            renderBundlesInCart(products, bundle_ids)
          }

          // update totals in cart
          updateTotals();

          // check Sample product
          samples_count = 0;
          for (let i = 0; i < products.length; i++) {
            // count Sample product
            if(products[i].title.indexOf("Sample") != -1){
              samples_count = samples_count + 1;
            }
          }
          if(samples_count >= max_free_samples){
            $(".product-box__sample").hide();
          }else{
            $(".product-box__sample").show();
          }

          $('.cart-content').removeClass('cart-content--loading')
        })
        .catch((error) => {
          console.log('catch', error)
        })
    })
    .catch((error) => {
      console.log('catch', error)
    })
}

function IsJsonString (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

// because cart api get doesnt return the compare_at_price we need to get the value from the product details call
function getComparePrice (url) {
  let aux = $.ajax({
    type: 'GET',
    url: '/products/' + url + '.js',
    cache: false,
    async: false,
    dataType: 'json'
  }).responseText

  if (IsJsonString(aux)) {
    if (aux) {
      return JSON.parse(aux)
    } else {
      return null
    }
  } else {
    // openAlert('Please refresh the page')
  }
}

// get a random quote for shopping cart
function get_quote_random () {
  let aux = document.getElementById('cart_quotes').value
  if (aux.length > 0) {
    aux = aux.split(';')
    const min = 0
    const max = 9
    return aux[Math.floor(Math.random() * (max - min + 1) + min)]
  } else {
    return ''
  }
}

// generate the dom element with the product details info
function generateProductElement (oneProduct, bundle_id) {
  let prod_elem = document.createElement('div')
  prod_elem.className = 'cart-item' + (!oneProduct.price ? ' free-sample' : '')
  prod_elem.setAttribute('id', oneProduct.id)

  if (bundle_id) {
    prod_elem.setAttribute('bundle_id', bundle_id)
  }

  // image
  let prod_div_img = document.createElement('div')
  let prod_img = document.createElement('img')
  prod_img.src = oneProduct.image
  prod_img.className = 'cart-item-details__image'
  prod_div_img.appendChild(prod_img)

  // details
  let prod_details = document.createElement('div')
  prod_details.className = 'cart-item-details'

  // title
  let prod_details_title = document.createElement('div')
  prod_details_title.className = 'cart-item-details__title'
  prod_details_title.innerHTML = oneProduct.product_title

  // quote
  let prod_details_quote = document.createElement('div')
  prod_details_quote.className = 'cart-item-details__quote'

  // check variant
  prod_details_quote.innerHTML = get_quote_random()

  if (oneProduct.options_with_values && oneProduct.options_with_values[0].name) {
    if (oneProduct.options_with_values[0].name.toLowerCase() == 'size') {
      prod_details_quote.innerHTML = oneProduct.variant_title.toLowerCase() + ' - ' + get_quote_random()
    }
  }

  // info
  let prod_details_info = document.createElement('div')
  prod_details_info.className = 'cart-item-details__info'

  // quantity
  let prod_details_quantity = document.createElement('div')
  prod_details_quantity.className = 'cart-item-details__quantity'

  let prod_inc_dec = document.createElement('div')
  let aux = document.createElement('button')
  aux.className = 'cart-item-details__minus'
  aux.innerHTML = icon_minus
  aux.setAttribute('id', 'minus-' + oneProduct.id)
  aux.setAttribute("onclick", 'updateProductCart(' + (oneProduct.quantity - 1) + ',' + oneProduct.id + ', \'' + oneProduct.handle + '\')')
  prod_inc_dec.appendChild(aux)
  prod_details_quantity.appendChild(prod_inc_dec)

  aux = document.createElement('div')
  aux.className = 'item-quantity'
  aux.setAttribute('id', 'quantity-' + oneProduct.id)
  aux.innerHTML = oneProduct.quantity
  prod_details_quantity.appendChild(aux)

  prod_inc_dec = document.createElement('div')
  aux = document.createElement('button')
  aux.className = 'cart-item-details__plus'
  aux.innerHTML = icon_plus
  aux.setAttribute('id', 'plus-' + oneProduct.id)
  if (oneProduct.price > 0) {
    aux.setAttribute('onclick', 'updateProductCart(' + (oneProduct.quantity + 1) + ',' + oneProduct.id + ', \'' + oneProduct.handle + '\')')
  }
  prod_inc_dec.appendChild(aux)
  prod_details_quantity.appendChild(prod_inc_dec)

  prod_details_info.appendChild(prod_details_quantity)

  // price
  let aux_compare = null
  aux = document.createElement('div')
  let aux_compare_price = getComparePrice(oneProduct.handle)

  aux_compare = document.createElement('span')
  aux_compare.setAttribute('id', 'price-' + oneProduct.id)

  if (aux_compare_price) {
    if ((aux_compare_price.compare_at_price > 0) || (oneProduct.discounted_price != oneProduct.price)) {
      aux_compare.className = 'price-box__sale'
    } else {
      aux_compare.className = ' price-box__full'
    }
  } else {
    aux_compare.className = ' price-box__full'
  }

  // check if the product as a discounted price
  if (oneProduct.discounted_price != oneProduct.price) {
    aux_compare.innerHTML = '$' + (oneProduct.discounted_price / 100).toFixed(2)
  } else {
    aux_compare.innerHTML = '$' + (oneProduct.price / 100).toFixed(2)
  }
  aux.appendChild(aux_compare)

  if (aux_compare_price) {
    if ((aux_compare_price.compare_at_price > 0) || (oneProduct.discounted_price != oneProduct.price)) {
      aux_compare = document.createElement('span')
      aux_compare.className = 'price-box__compare'
      if (oneProduct.discounted_price != oneProduct.price) {
        aux_compare.innerHTML = '$' + (oneProduct.original_price / 100).toFixed(2)
      } else {
        aux_compare.innerHTML = '$' + (aux_compare_price.compare_at_price / 100).toFixed(2)
      }
      aux.appendChild(aux_compare)
    }
  }

  // if price == 0 is a Sample
  if (oneProduct.price == 0) {
    samples_count = samples_count + oneProduct.quantity
    samples_list.push(oneProduct.id)
  }

  aux.className = 'cart-item-details__price'
  prod_details_info.appendChild(aux)

  aux_delete = document.createElement('div')
  aux_delete.className = 'cart-item-details__delete'
  aux = document.createElement('button')
  aux.innerHTML = icon_delete

  // if bundle pass bundle id
  aux.setAttribute('onclick', 'updateProductCart(0,' + oneProduct.id + ', \'' + oneProduct.handle + '\')')

  aux_delete.appendChild(aux)

  prod_details.appendChild(prod_details_title)
  prod_details.appendChild(prod_details_quote)

  prod_details.appendChild(prod_details_info)
  prod_details.appendChild(aux_delete)

  prod_elem.appendChild(prod_div_img)
  prod_elem.appendChild(prod_details)

  return prod_elem
}

// update a bundle quantity
function updateBundleCart (quantity, bundle_id, products, sign) {
  if (IsJsonString(products)) {
    let aux_products = JSON.parse(products)
    let aux_bundle = document.querySelectorAll('[bundle_id="' + bundle_id + '"]')
    if (aux_bundle) {
      let addData = {
        'updates': {}
      }

      for (let i = 0; i < aux_products.length; i++) {
        if (sign == 0) {
          addData['updates'][aux_products[i]] = quantity
        } else {
          let temp = document.querySelector(`[bundle-product-id="${aux_products[i]}"]`)
          if (temp) {
            temp2 = temp.getAttribute('bundle-product-quantity')
            if (!isNaN(temp2)) {
              if (Number(temp2) == 1) {
                addData['updates'][aux_products[i]] = quantity
              } else {
                addData['updates'][aux_products[i]] = Number(temp2) * quantity
              }
            }
          }
        }
      }

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(addData)
      })
        .then((response) => {
          if (response.status === 200) {
            //refresh cart
            if (quantity == 0) {
              // delete product
              deleteProduct(bundle_id)
            } else {
              // update quantity
              updateProductQuantitiesBundle(bundle_id, quantity, products)
            }
            // update totals
            updateTotals()
          }
        })
        .catch((error) => {
          console.log('catch', error)
        })
    }
  } else {
    // openAlert('Please refresh the page')
  }
}

//update quantity on Bundle
function updateProductQuantitiesBundle (bundle_id, quantity, products) {
  let aux = document.getElementById('minus-' + bundle_id)
  aux.setAttribute('onclick', 'updateBundleCart(' + (quantity - 1) + ',' + bundle_id + ',"' + products + '",-1)')
  aux = document.getElementById('plus-' + bundle_id)
  aux.setAttribute('onclick', 'updateBundleCart(' + (quantity + 1) + ',' + bundle_id + ',"' + products + '",1)')

  aux = document.getElementById('quantity-' + bundle_id)
  aux.innerHTML = quantity

  if (IsJsonString(products)) {
    tempJson = JSON.parse(products)
    tempJson.forEach(elem => {
      let tempProduct = document.querySelector(`[bundle-product-id="${elem}"]`)
      let tempValue = tempProduct.getAttribute('bundle-product-quantity')
      let tempQuantity = document.querySelector(`[bundle-quantity-id="${elem}"]`)
      if (tempQuantity) tempQuantity.innerHTML = 'Quantity: ' + (Number(tempValue) * quantity)
    })
  }
}

// update a product quantity
function updateProductCart (quantity, id, handle) {
  let addData = {
    updates: {
      [id]: quantity
    }
  }

  let current_quantity = document.getElementById('quantity-' + id).innerHTML
  current_quantity = parseFloat(current_quantity)

  let continueToUpdate = true

  // we need to check if it is an increment or not to the current product to check if its a sample
  if (quantity > 0) {
    if (quantity > current_quantity) {
      continueToUpdate = canAddIt(handle)
    }
  }

  // check if the product quantity can be added (if its a sample)
  if (continueToUpdate) {
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(addData)
    })
      .then((response) => {

        
        if (response.status === 200) {

          
          //refresh cart
          if (quantity == 0) {
            // delete product
            deleteProduct(id)
          } else {
            // update quantity
            updateProductQuantities(id, quantity, handle, '')
            // if we increase the quantity of a sample, update the counter
            let aux_price = document.getElementById('price-' + id).innerHTML
            aux_price = aux_price.replace('$', '')
            aux_price = parseFloat(aux_price)

            if (aux_price == 0) {
              if (quantity > current_quantity) {
                samples_count++
              } else {
                samples_count--
                // remove sample from array
                samples_list = samples_list.filter(obj => obj !== id)
                if (samples_count < 0) { samples_count = 0; samples_list = []; }
              }
            }
          }

          if(freeProductId == id && quantity == 0){
            $.cookie("gift-removed", 1, { path : "/" });
          }
          if(bagProductId == id && quantity == 0){
            $.cookie("bag-removed", 1, { path : "/" });
          }
          updateTotals()
        }
      })
      .catch((error) => {
        console.log('catch', error)
      })
  }
}

function updateProductQuantities (id, quantity, handle, bundle_id) {
  let aux = document.getElementById('minus-' + id)
  aux.setAttribute('onclick', 'updateProductCart(' + (quantity - 1) + ',' + id + ', \'' + handle + '\')')
  aux = document.getElementById('plus-' + id)
  aux.setAttribute('onclick', 'updateProductCart(' + (quantity + 1) + ',' + id + ', \'' + handle + '\')')

  aux = document.getElementById('quantity-' + id)
  aux.innerHTML = quantity
}

// update totals in cart
function updateTotals () {
  fetch('/cart.js', {
    method: 'GET'
  })
    .then((response) => {
      response.json()
        .then((result) => {
          updateQuantityHeader(result.item_count)
          updateFreeShippingProgress(result.total_price)

         
          let aux = document.getElementById('cart-checkout-total')
          aux.innerHTML = '$' + (result.items_subtotal_price / 100).toFixed(2)

          // calculate the subtotal (without discount) of the products
          let temp_subtotal_savings = calculateSubtotalAndSavingOnProducts()
          aux = document.getElementById('cart-subtotal')
          aux.innerHTML = '$' + temp_subtotal_savings[0]
          // aux.innerHTML = '$' + ((result.items_subtotal_price - result.total_discount) / 100).toFixed(2)

          aux = document.getElementById('cart-savings')
          // let sign = (temp_savings <= 0) ? '' : '-'
          aux.innerHTML = ' $' + temp_subtotal_savings[1]

          // show savings div if there is any
          if (temp_subtotal_savings[1] > 0) {
            $('#resume-total__savings').show()
          } else {
            $('#resume-total__savings').hide()
          }

          // check minimum order amount
          let temp_min = document.getElementById('minimum_order_amount').value
          if (temp_min.length > 0) {
            temp_min = parseFloat(temp_min)
            temp_min = temp_min * 100
          } else {
            temp_min = 0
          }

          // check maximum order amount
          let temp_max = document.getElementById('maximum_order_amount').value
          if (temp_max.length > 0) {
            temp_max = parseFloat(temp_max)
            temp_max = temp_max * 100
          } else {
            temp_max = 0
          }

          if ((result.total_price >= temp_min) && (result.total_price <= temp_max)) {
            // display checkout
            $('#cart-checkout-button').show()
            $('#cart-checkout-minimum').hide()
            $('#cart-checkout-maximum').hide()
          } else {
            // hide checkout
            $('#cart-checkout-button').hide()
            if (result.total_price > temp_max) {
              $('#cart-checkout-maximum').show()
              $('#cart-checkout-minimum').hide()
            } else {
              $('#cart-checkout-maximum').hide()
              $('#cart-checkout-minimum').show()
            }
          }

          // show/hide fields based on cart total
          if (result.total_price > 0) {
            $('.cart-drawer__empty-button').hide()
            $('#message-empty-card').hide()
            $('#resume-total-box').show()
            $('.product-box__sample').show()
            $('.free-samples__slider').css('opacity','1')
            $('.free-samples--shadow').css('position', 'relative')
            $('.free-samples--shadow').css('top', 'unset')
            $('.free-samples').css('pointer-events', 'unset')
            $('.free-samples__title').show()
            $('.cart-checkout').show()
            $('.cart-drawer--line').show()
            $('.cart-free-ship').show()
          } else {
            $('.free-samples').css('pointer-events', 'none')
            $('.free-samples__slider').css('opacity', '0')
            $('.free-samples--shadow').css('position', 'absolute')
            $('.free-samples--shadow').css('top', '0')
            $('#message-empty-card').show()
            $('.cart-drawer__empty-button').show()
            $('#resume-total-box').hide()
            $('.product-box__sample').hide()
            $('.free-samples__title').hide()
            $('.cart-checkout').hide()
            $('.cart-drawer--line').hide()
            $('.cart-free-ship').hide()
          }

          setTimeout(() => {
            let aux = document.querySelector('.free-samples__slider .slick-prev')
            if (aux) {
              aux.click()
            }
          }, 500)

          // disable add button on samples if the max samples is reached
          if (samples_count >= max_free_samples) {
            $('.product-box__sample').hide()
          } else {
            $('.product-box__sample').show()
            checkSamplesButtonText()
          }

          checkDiscount()
          checkSamples(result)

          // check Free Gift product
          checkFreeGift(); 
          
        })
        .catch((error) => {
          console.log('catch', error)
        })
    })
    .catch((error) => {
      console.log('catch', error)
    })
}

// update header cart count
function updateQuantityHeader (quantity) {
  let cart_count = document.getElementById('drawer-cart-count')
  cart_count.innerHTML = quantity

  let cart_count_header = document.getElementById('cart-quantity')
  cart_count_header.getElementsByTagName('span')[0].innerHTML = quantity
  cart_count_header.classList.remove('quantity--hide')
}

// delete product from DOM
function deleteProduct (id) {
  let aux = document.getElementById(id)
  if (aux) {
    let aux_quantity = document.getElementById('quantity-' + id).innerHTML
    aux_quantity = parseFloat(aux_quantity)
    let aux_price = document.getElementById('price-' + id).innerHTML
    aux_price = aux_price.replace('$', '')
    aux_price = parseFloat(aux_price)

    if (aux_price == 0) {
      samples_count = samples_count - aux_quantity
      samples_list = samples_list.filter(obj => obj !== id)
      if (samples_count < 0) { samples_count = 0; samples_list = []; }
    }
    aux.remove()
  }
}

// Open Search bar drawer
function openSearchBar () {
  localStorage.setItem('last_search_results', '')

  $('.screen-overlay-search').toggleClass('show')
  const aux = $('#SearchDrawer').css('display')
  if (aux === 'none') {
    $('#SearchDrawer').slideDown()
    $('.klaviyo-newsletter').css('z-index',4)
    document.querySelector('body').classList.add('search-open')
    document.querySelector('html').classList.add('html-full-height')
    $('.top-searched').show()
    $('#search-drawer-top').val('')
    $('#search-drawer-top').focus()
    // if (/iPhone/i.test(navigator.userAgent)) {
    //   if (offcanvas_id == '#cart-right-side') {
    //     setTimeout(() => {
    //       $('body').addClass('body-no-scroll')
    //     }, 1000)
    //   }
    // }
  } else {
    $('.klaviyo-newsletter').css('z-index', 6)
    $('#SearchDrawer').slideUp()
    // $('.ui-menu').css('visibility', 'hidden')
    document.querySelector('body').classList.remove('search-open')
    $('body').removeClass('body-no-scroll')
    $('html').removeClass('html-full-height')
    window.scrollTo(0, lastScrollPosition)
  }
}

// get product information based on handle to display details on cart
function getProductInfo (handle) {
  let aux = $.ajax({
    type: 'GET',
    url: '/products/' + handle + '.js',
    cache: false,
    async: false,
    dataType: 'json'
  }).responseText

  if (IsJsonString(aux)) {
    if (aux) {
      return JSON.parse(aux)
    } else {
      return null
    }
  } else {
    // openAlert('Please refresh the page')
  }
}

// check for the discount in cart and update the totals
function checkDiscount () {
  let sessionData = sessionStorage.getItem('scDiscountData')
  let temp_subtotal_savings = calculateSubtotalAndSavingOnProducts()
  let mainContainer = document.getElementById('cart-checkout-total-visible')
  mainContainer.innerHTML = ''
  let addTotal = false
  let visibleTotal = temp_subtotal_savings[0] ? Number(temp_subtotal_savings[0]) : 0
  let visibleSavings = temp_subtotal_savings[1] ? Number(temp_subtotal_savings[1]) : 0

  if (IsJsonString(sessionData)) {
    let sessionJson = JSON.parse(sessionData)
    if (sessionJson && sessionJson.total) {
      if (sessionJson.subtotal) {

        let aux_subtotal = parseFloat(sessionJson.subtotal)
        let aux_total = parseFloat(sessionJson.total)

        if ((aux_total - aux_subtotal) > 0) {
          const discountSavings = aux_total - aux_subtotal
          let currentSavings = temp_subtotal_savings[1]

          if (!isNaN(currentSavings)) {
            currentSavings = Number(currentSavings) + Number(discountSavings)
            document.getElementById('cart-savings').innerHTML = '$' + currentSavings.toFixed(2)

            currentSavings = temp_subtotal_savings[0] - currentSavings

            let discountDiv = document.createElement('div')
            discountDiv.style.color = '#ff50d8'
            discountDiv.innerHTML = '$' + currentSavings.toFixed(2)
            mainContainer.appendChild(discountDiv)
            $('#resume-total__savings').show()
          }

          let totalDiv = document.createElement('div')
          totalDiv.style.color = '#000'
          let aux_subtotalFull = document.getElementById('cart-subtotal')
          aux_subtotalFull = aux_subtotalFull ? aux_subtotalFull.innerHTML.replace('$', '').trim() : '0'
          aux_subtotalFull = aux_subtotalFull ? parseFloat(aux_subtotalFull) : 0
          totalDiv.innerHTML = '$' + aux_subtotalFull.toFixed(2)
          if (currentSavings > 0) {
            totalDiv.style.textDecoration = 'line-through'
          }
          mainContainer.appendChild(totalDiv)
        } else {
          addTotal = true
        }
      } else {
        $('#resume-total__savings').hide()
        visibleSavings = 0
        addTotal = true
      }
    } else {
      addTotal = true
    }
  } else {
    addTotal = true
  }

  if (addTotal) {
    if (visibleSavings > 0) {
      document.getElementById('cart-savings').innerHTML = '$' + visibleSavings.toFixed(2)
      $('#resume-total__savings').show()

      visibleSavings = visibleTotal - visibleSavings

      let discountDiv = document.createElement('div')
      discountDiv.style.color = '#ff50d8'
      discountDiv.innerHTML = '$' + visibleSavings.toFixed(2)
      mainContainer.appendChild(discountDiv)

    } else {
      $('#resume-total__savings').hide()
    }

    let totalDiv = document.createElement('div')
    totalDiv.style.color = '#000'
    totalDiv.innerHTML = '$' + visibleTotal.toFixed(2)
    if (visibleSavings > 0) {
      totalDiv.style.textDecoration = 'line-through'
    }
    mainContainer.appendChild(totalDiv)
  }
}

// check if the cookie for newsletter exists to not display popup
function checkPopoupCookie () {
  try {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('newsletter_framar='))
      .split('=')[1]

    if (cookieValue !== 'false') {
      $('#newsletter_popup').animate({ bottom: '10px' }, 1000)
    }
  } catch (err) {
    $('#newsletter_popup').animate({ bottom: '10px' }, 1000)
  }
}

// special function to render the bundles in cart
function renderBundlesInCart (products, bundle_ids) {
  let cart_drawer_content = document.getElementById('cart-drawer-content')

  for (let i = 0; i < bundle_ids.length; i++) {
    //get list of ids
    let products_id_aux = []
    let total_products_in_bundle = 0
    let jsonOriginal = null
    for (let j = 0; j < products.length; j++) {
      if (products[j].properties) {
        if (products[j].properties['_bundle_id']) {
          if (products[j].properties['_bundle_id'] === bundle_ids[i].bundle_id) {
            products_id_aux.push(products[j].variant_id)
          }
        }

        if (j == 0) {
          jsonOriginal = products[j].properties['_original']
        }
      }
    }

    let bundle_info = getProductInfo(bundle_ids[i].bundle_handle)

    let prod_elem = document.createElement('div')
    prod_elem.className = 'cart-item cart-item--bundle'
    prod_elem.setAttribute('id', bundle_ids[i].bundle_id)
    prod_elem.setAttribute('original-json', jsonOriginal)
    prod_elem.style.height = 'auto'
    prod_elem.style.display = 'block'

    let divContainer = document.createElement('div')
    divContainer.style.display = 'flex'
    divContainer.style.flexDirection = 'row'

    let prod_div_img_main = document.createElement('div')
    let prod_img_main = document.createElement('img')
    prod_img_main.className = 'cart-item-details__image'

    if (bundle_info && bundle_info.images.length) {
      prod_img_main.src = bundle_info.images[0]
    }
    prod_div_img_main.appendChild(prod_img_main)

    // details
    let prod_details = document.createElement('div')
    prod_details.className = 'cart-item-details cart-item-details--bundle'
    prod_details.style.height = 'auto'
    prod_details.style.width = '100%'

    let prod_details_parent = document.createElement('div')
    prod_details_parent.className = 'cart-item-details--bundle-info'

    // title
    let prod_details_title = document.createElement('div')
    prod_details_title.className = 'cart-item-details__title'
    prod_details_title.innerHTML = bundle_info.title

    // quote
    let prod_details_quote = document.createElement('div')
    prod_details_quote.className = 'cart-item-details__quote'
    prod_details_quote.innerHTML = get_quote_random()

    // info
    let prod_details_info = document.createElement('div')
    prod_details_info.className = 'cart-item-details__info product-bundle--details-info'

    // quantity
    let prod_details_quantity = document.createElement('div')
    prod_details_quantity.className = 'cart-item-details__quantity'

    let quantity_bundle = (bundle_ids[i].quantity / bundle_ids[i].aux_bundle_quantity_unique).toFixed(0)

    let prod_inc_dec = document.createElement('div')
    let aux = document.createElement('button')
    aux.className = 'cart-item-details__minus'
    aux.innerHTML = icon_minus
    aux.setAttribute('id', 'minus-' + bundle_ids[i].bundle_id)
    aux.setAttribute("onclick", 'updateBundleCart(' + (Number(quantity_bundle) - 1) + ',' + bundle_ids[i].bundle_id + ',"' + JSON.stringify(products_id_aux) + '",-1)')
    prod_inc_dec.appendChild(aux)
    prod_details_quantity.appendChild(prod_inc_dec)

    aux = document.createElement('div')
    aux.className = 'item-quantity'
    aux.setAttribute('id', 'quantity-' + bundle_ids[i].bundle_id)
    aux.innerHTML = quantity_bundle
    prod_details_quantity.appendChild(aux)

    prod_inc_dec = document.createElement('div')
    aux = document.createElement('button')
    aux.className = 'cart-item-details__plus'
    aux.innerHTML = icon_plus
    aux.setAttribute('id', 'plus-' + bundle_ids[i].bundle_id)
    aux.setAttribute("onclick", 'updateBundleCart(' + (Number(quantity_bundle) + 1) + ',' + bundle_ids[i].bundle_id + ',"' + JSON.stringify(products_id_aux) + '",1)')
    prod_inc_dec.appendChild(aux)
    prod_details_quantity.appendChild(prod_inc_dec)

    prod_details_info.appendChild(prod_details_quantity)

    // price
    let aux_price = getPriceElementBundle(bundle_info, bundle_ids[i].bundle_id)
    prod_details_info.appendChild(aux_price)


    prod_details_parent.appendChild(prod_details_title)
    prod_details_parent.appendChild(prod_details_quote)
    prod_details.appendChild(prod_details_parent)

    for (let j = 0; j < products.length; j++) {
      if (products[j].properties && Object.keys(products[j].properties).length) {
        // loop in product quantity
        let originalQuantity = JSON.parse(products[j].properties['_original'])
        let bundleQuantity = 1
        if (originalQuantity) {
          let temp = originalQuantity.find(elem => elem.id == products[j].handle)
          if (temp) bundleQuantity = temp.quantity
        }

          if (products[j].properties['_bundle_id']) {
            if (products[j].properties['_bundle_id'] === bundle_ids[i].bundle_id) {
              // add this product

              let divOneProduct = document.createElement('div')
              divOneProduct.className = 'product-bundle'
              divOneProduct.setAttribute('bundle-product-id', products[j].id)
              divOneProduct.setAttribute('bundle-product-quantity', bundleQuantity)

              let prod_div_img = document.createElement('div')
              prod_div_img.className = 'product-bundle__image_div'

              // let prod_img = document.createElement('img')
              // prod_img.src = products[j].image
              // prod_img.className = 'product-bundle__image'
              // prod_div_img.appendChild(prod_img)

              let prod_title = document.createElement('div')
              prod_title.className = 'product-bundle__title-span'
              let tempProdTitle = document.createElement('span')
              tempProdTitle.innerHTML = products[j].title
              prod_title.appendChild(tempProdTitle)

              //quantity
              let prod_bundle_quantity = document.createElement('span')
              prod_bundle_quantity.setAttribute('bundle-quantity-id', products[j].id)
              prod_bundle_quantity.innerHTML = 'Quantity: ' + (bundleQuantity * quantity_bundle)
              prod_title.appendChild(prod_bundle_quantity)

              prod_div_img.appendChild(prod_title)

              divOneProduct.appendChild(prod_div_img)

              let prod_prices = document.createElement('div')
              prod_prices.style.display = 'flex'
              let tempItemPrice = getPriceElement(products[j].properties)
              tempItemPrice.className = 'product-bundle__item-price'
              prod_prices.appendChild(tempItemPrice)

              divOneProduct.appendChild(prod_prices)

              prod_details.appendChild(divOneProduct)
            }
          }
        //}
      }
    }

    // prod_details.appendChild(prod_details_info)
    divContainer.appendChild(prod_div_img_main)
    divContainer.appendChild(prod_details)
    prod_elem.appendChild(divContainer)
    prod_elem.appendChild(prod_details_info)
    // prod_elem.appendChild(prod_details)

    aux_delete = document.createElement('div')
    aux_delete.className = 'cart-item-details__delete'
    aux = document.createElement('button')
    aux.innerHTML = icon_delete
    aux.setAttribute('onclick', 'updateBundleCart(0,' + bundle_ids[i].bundle_id + ',"' + JSON.stringify(products_id_aux) + '",0)')
    aux_delete.appendChild(aux)

    prod_details.appendChild(aux_delete)

    cart_drawer_content.appendChild(prod_elem)
    // cart_drawer_content.appendChild(prod_details_info)
  }
}

// get price of fake bundle product
function getPriceElement (element) {
  let aux_compare = null
  aux = document.createElement('div')

  aux_compare = document.createElement('span')

  if (element['_compare_price'].length > 0) {
    aux_compare.className = 'price-box__sale'
  }

  aux_compare.innerHTML = '$' + (Number(element['_price']) / 100).toFixed(2)
  // if (element['_compare_price'].length > 0) {
  // } else {
  //   aux_compare.innerHTML = '$' + (Number(element['_compare_price']) / 100).toFixed(2)
  // }

  aux.appendChild(aux_compare)

  if (element['_compare_price'].length > 0) {
    aux_compare = document.createElement('span')
    aux_compare.className = 'price-box__compare'
    aux_compare.innerHTML = '$' + (Number(element['_compare_price']) / 100).toFixed(2)
    aux.appendChild(aux_compare)
  }
  aux.className = 'cart-item-details__price'
  return aux
}

// get price of products inside the bundle
function getPriceElementBundle (element, bundle_id) {

  let aux_compare = null
  aux = document.createElement('div')
  let aux_compare_price = getComparePrice(element.handle)

  aux_compare = document.createElement('span')
  aux_compare.setAttribute('id', 'price-' + bundle_id)

  if ((aux_compare_price.compare_at_price > 0) || (element.discounted_price && (element.discounted_price != element.price))) {
    aux_compare.className = 'price-box__sale'
  } else {
    aux_compare.className = ' price-box__full'
  }

  // check if the product as a discounted price
  if (element.discounted_price && (element.discounted_price != element.price)) {
    aux_compare.innerHTML = '$' + (element.discounted_price / 100).toFixed(2)
  } else {
    aux_compare.innerHTML = '$' + (element.price / 100).toFixed(2)
  }
  aux.appendChild(aux_compare)

  if ((aux_compare_price.compare_at_price > 0) || (element.discounted_price && (element.discounted_price != element.price))) {
    aux_compare = document.createElement('span')
    aux_compare.className = 'price-box__compare'
    if (element.discounted_price && (element.discounted_price != element.price)) {
      aux_compare.innerHTML = '$' + (element.original_price / 100).toFixed(2)
    } else {
      aux_compare.innerHTML = '$' + (aux_compare_price.compare_at_price / 100).toFixed(2)
    }
    aux.appendChild(aux_compare)
  }

  aux.className = 'cart-item-details__price'

  return aux
}

// check if the samples are the only items in cart, in that case remove them
function checkSamples (cartContent) {
  if (cartContent.total_price == 0) {
    if (cartContent.items.length > 0) {
      let addData = {
        updates: {}
      }

      cartContent.items.forEach(element => {
        addData.updates[element.id] = 0
      })

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(addData)
      })
        .then((response) => {
          if (response.status === 200) {
            cartContent.items.forEach(element => {
              deleteProduct(element.id)
            })
            updateTotals()
          }
        })
        .catch((error) => {
          console.log('catch', error)
        })
    }
  }
}

// change sample button text and disabled after click on it
function changeSampleButton (elem) {
  elem.style.padding = '15px 29px'
  elem.style.display = 'flex'
  elem.style.alignItems = 'center'
  elem.style.justifyContent = 'center'
  elem.innerHTML = 'added'
  elem.disabled = true
  elem.classList.add('is-disabled')
}

// change the innerhtml text on the sample button when there is not samples on the basket
function checkSamplesButtonText () {
  let temp = document.querySelectorAll('.product-box__sample')
  // if (samples_count < max_free_samples) {
  if (samples_count == 0) {
    temp.forEach((elem) => {
      elem.innerHTML = 'add'
      elem.style.padding = '15px 37px'
      elem.classList.remove('is-disabled')
      elem.disabled = false
      let sampleId = elem.getAttribute('sample-id')
      samples_list = samples_list.filter(obj => obj !== sampleId)
    })
  } else {
    temp.forEach((elem) => {
      let sampleId = elem.getAttribute('sample-id')
      if (!isNaN(sampleId)) {
        if (samples_list.includes(Number(sampleId))) {
          changeSampleButton(elem)
        } else {
          elem.classList.remove('is-disabled')
          elem.innerHTML = 'add'
          elem.style.padding = '15px 37px'
          elem.disabled = false
        }
      }
    })
  }
}

function calculateSubtotalAndSavingOnProducts () {
  const cartContent = document.querySelector('#cart-drawer-content')
  const cartContentInfo = cartContent.querySelectorAll('.cart-item-details__info')
  let results = [0,0]

  cartContentInfo.forEach((elem) => {
    let tempQuantity = elem.querySelector('.item-quantity')
    tempQuantity = tempQuantity.innerHTML.trim()
    let tempPriceCompare = elem.querySelector('.price-box__compare')
    let tempPriceSale = elem.querySelector('.price-box__sale')
    let tempPriceFull = elem.querySelector('.price-box__full')

    if (tempPriceFull) {
      tempPriceFull = tempPriceFull.innerHTML.replace('$', '').trim()
      if (!isNaN(tempPriceFull)) {
        results[0] = results[0] + (Number(tempPriceFull) * Number(tempQuantity))
      }
    } else {
      if (tempPriceCompare && tempQuantity && tempPriceSale) {
        tempPriceCompare = tempPriceCompare.innerHTML.replace('$', '').trim()
        tempPriceSale = tempPriceSale.innerHTML.replace('$', '').trim()

        if (tempPriceCompare && !isNaN(tempPriceCompare) && tempPriceSale && !isNaN(tempPriceSale) && tempQuantity && !isNaN(tempQuantity)) {
          results[0] = results[0] + (Number(tempPriceCompare) * Number(tempQuantity))
          results[1] = results[1] + ((Number(tempPriceCompare) - Number(tempPriceSale)) * Number(tempQuantity))
        }
      }
    }
  })

  results[0] = results[0].toFixed(2)
  results[1] = results[1].toFixed(2)

  return results
}

function scrollUpCart () {
  $("#cart-right-side").animate({ scrollTop: 0 }, "slow")
}

function getResultsCount (searchTerm) {
  const currentLocale = document.getElementById('current_locale').value
  const resultText = currentLocale == 'en' ? 'results' : 'résultats'
  let tempLastSearchResults = localStorage.getItem('last_search_results')
  if (IsJsonString(tempLastSearchResults)) {
    tempLastSearchResults = JSON.parse(tempLastSearchResults)
  }

  if (GloboEmbedFilterConfig && GloboEmbedFilterConfig.api && GloboEmbedFilterConfig.api.searchUrl) {
    fetch(`${GloboEmbedFilterConfig.api.searchUrl}?shop=foilit.myshopify.com&locale=${currentLocale}&term=${searchTerm}&excludeTags%5B%5D=__category%3Asamples&excludeTags%5B%5D=sample&excludeTags%5B%5D=hide_product&excludeTags%5B%5D=__isbundle&tags=`, {
      method: 'GET'
    })
      .then((response) => {
        response.json()
          .then((resultSearch) => {
            if (resultSearch && resultSearch.result) {
              let searchHeader = document.querySelector('#search_results_count')
              if (searchHeader) {
                if (searchHeader) searchHeader.style.display = ''
                let ResultsContent = document.querySelector('.instant-search-results')
                let viewAllElem = document.querySelector('.instant-search-results__view-all')

                let notFoundDiv = document.createElement('div')
                notFoundDiv.className = 'instant-search-results__notfound'
                notFoundDiv.innerHTML = 'No products found'

                if (!resultSearch.result.isEmpty) {
                  // display results
                  if (resultSearch.result.total_product) {
                    searchHeader.innerHTML = resultSearch.result.total_product + ' ' + resultText

                    let results = {
                      products: []
                    }

                    resultSearch.result.products.forEach((elem) => {
                      let compareAtPrice = elem.variants.length > 0 && elem.variants[0].compare_at_price ? elem.variants[0].compare_at_price : elem.compare_at_price ? elem.compare_at_price : null;
                      let price = elem.variants.length > 0 && elem.variants[0].price ? elem.variants[0].price : elem.compare_at_price ? elem.compare_at_price : null;
                      let tempProd = {
                        main_image: elem.image.src,
                        price: price ? price.toFixed(2) : null,
                        sec_image: '',
                        title: elem.title,
                        handle: elem.handle,
                        compare_at_price: compareAtPrice ? compareAtPrice.toFixed(2) : null,
                      }

                      if (elem.metafields.length) {
                        elem.metafields.forEach(function (metafield){
                          if (metafield.namespace === 'judgeme' && metafield.key === 'badge') {
                            tempProd.badge = metafield.value;
                          }

                          if (metafield.namespace === 'reviews' && metafield.key === 'rating_count') {
                            tempProd.reviews = metafield.value;
                          }
                        });
                      }

                      // find gif image
                      elem.images.forEach((oneImage) => {
                        if (oneImage.src.indexOf('.gif') > -1 || oneImage.src.indexOf('.GIF') > -1) {
                          tempProd.sec_image = oneImage.src
                        }
                      })

                      if (!tempProd.sec_image.length) {
                        if (elem.images.length > 1) {
                          tempProd.sec_image = elem.images[1].src
                        } else {
                          tempProd.sec_image = elem.image.src
                        }
                      }

                      const regex = /(.(jpg|gif|jpeg))/gm
                      const subst = `_500x$1`

                      tempProd.main_image = tempProd.main_image.replace(regex, subst)
                      tempProd.sec_image = tempProd.sec_image.replace(regex, subst)

                      results.products.push(tempProd)
                    })

                    let customTags = ['<%', '%>']
                    Mustache.tags = customTags
                    let templateResults = document.querySelector('#resultsTemplate').innerHTML

                    if (!isArrayEqual(results.products, tempLastSearchResults)) {
                      // is equal ignoring order and duplicates
                      $('.instant-search-results-container').addClass('instant-search-results-container--loading')

                      temp = Mustache.render(templateResults, results, {}, customTags)
                      ResultsContent.innerHTML = temp

                      setTimeout(() => {
                        $('.instant-search-results-container').removeClass('instant-search-results-container--loading')
                      }, 500)
                    }

                    viewAllElem.style.opacity = '1'
                    viewAllElem.setAttribute("onclick", 'window.location = "/search?q=' + searchTerm + '"')

                    localStorage.setItem('last_search_results', JSON.stringify(results.products))

                  } else {
                    viewAllElem.style.opacity = '0'
                    searchHeader.innerHTML = ''
                    ResultsContent.innerHTML = ''
                    ResultsContent.appendChild(notFoundDiv)
                  }

                } else {
                  viewAllElem.style.opacity = '0'
                  searchHeader.innerHTML = ''
                  ResultsContent.innerHTML = ''
                  ResultsContent.appendChild(notFoundDiv)
                }
              }
            }
          })
          .catch((error) => {
            console.log('catch', error)
          })
      })
      .catch((error) => {
        console.log('catch', error)
      })
  }
}

let isArrayEqual = function (x, y) {
  return _(x).xorWith(y, _.isEqual).isEmpty();
};

function addDCartScript () {
  let urlsDcart = ["https:\/\/cart-discount.herokuapp.com\/js\/storefront.min.js?c=21810544691\u0026shop=framar-canada.myshopify.com"]
  let sDcart = document.createElement('script')
  sDcart.type = 'text/javascript'
  sDcart.async = true
  sDcart.src = urlsDcart
  let xDcart = document.getElementsByTagName('script')[0]
  xDcart.parentNode.insertBefore(sDcart, xDcart)
}

// Control left-right menu drawer.
function openDrawerMenu (e, elem) {
  if (elem.id !== "button-burger") {
    Rebuy.SmartCart.show();
  }

  e.preventDefault()
  e.stopPropagation()
  let offcanvas_id = $(elem).attr('data-trigger')
  // lastScrollPosition = document.documentElement.scrollTop || document.body.scrollTop

  // addDCartScript()

  $(offcanvas_id).toggleClass('show')

  // update cart content
  $('body').toggleClass('offcanvas-active')
  $('.screen-overlay').toggleClass('show')

  if (/iPhone/i.test(navigator.userAgent)) {
    // if (offcanvas_id == '#cart-right-side') {
    //   setTimeout(() => {
    //     $('body').addClass('body-no-scroll')
    //     $('html').addClass('html-full-height')
    //     window.scrollTo(0, lastScrollPosition)
    //   }, 1000)
    // }
    if (offcanvas_id == '#menu-left-side') {
      $('body').addClass('body-no-scroll')
      $('html').addClass('html-full-height')
    }
  }
}

document.addEventListener('rebuy:smartcart.show', (event) => {
  const smartcart = event.detail.smartcart;
  // console.log('rebuy:smartcart.show: smartcart', smartcart);
  document.querySelector('#ps__widget_container').style.display = 'none';
});

document.addEventListener('rebuy:smartcart.hide', (event) => {
  const smartcart = event.detail.smartcart;
  // console.log('rebuy:smartcart.hide: smartcart', smartcart);
  document.querySelector('#ps__widget_container').style.display = 'block';
});

function closeSearch () {
  localStorage.setItem('last_search_results', '')

  document.getElementById('search-drawer-top').value = ''
  last_search = ''
  document.querySelector('.top-searched').style.display = 'none'
  document.querySelector('.instant-search-results').style.display = 'none'
  document.querySelector('.instant-search-results__view-all').style.opacity = '0'
  $('.search-drawer__container').css('border-bottom', '1px solid rgba(204, 204, 204, 0.45)')
  let searchHeader = document.querySelector('#search_results_count')
  if (searchHeader) searchHeader.style.display = 'none'
  if (searchHeader && searchHeader.innerHTML) searchHeader.innerHTML = ''
  document.querySelector('body').classList.remove('search-open')
  $('#SearchDrawer').slideUp()
  $('.screen-overlay-search').removeClass('show')

  $('body').removeClass('body-no-scroll')
  $('html').removeClass('html-full-height')
  window.scrollTo(0, lastScrollPosition)
}

// keep track of the last search item
let last_search = ''
let listenerAdded = false
let fullWindowHeight = window.innerHeight;

$(document).ready(function () {

  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

  // listener to scroll to discount code input
  // if (!isFirefox) {
  //   window.visualViewport.addEventListener('resize', event => {

  //     // check if the cart is opened
  //     let tempCart = document.querySelector('#cart-right-side')
  //     if (tempCart && tempCart.classList.contains('show')) {
  //       //android
  //       if (/Android/i.test(navigator.userAgent)) {
  //         if (fullWindowHeight > window.innerHeight) {
  //           document.querySelector('.cart-checkout').style.position = 'unset'
  //           let aTag = $('.cart-checkout')
  //           $('#cart-right-side').scrollTop($('.cart-content').height())

  //           let tempSChat = document.getElementById('shopify-chat')
  //           if (tempSChat) tempSChat.style.position = 'relative'
  //           tempSChat = document.getElementById('ShopifyChat')
  //           if (tempSChat) tempSChat.style.position = 'absolute'

  //         } else {
  //           document.querySelector('.cart-checkout').style.position = 'fixed'
  //           let tempSChat = document.getElementById('shopify-chat')
  //           if (tempSChat) tempSChat.style.position = 'unset'
  //           tempSChat = document.getElementById('ShopifyChat')
  //           if (tempSChat) tempSChat.style.position = 'fixed'
  //         }
  //       } else {
  //         let checkElement = document.activeElement
  //         if (checkElement) {
  //           checkElement = checkElement.getAttribute('id')
  //           if (checkElement) {
  //             // keyboard visible
  //             if (checkElement == 'code') {
  //               document.querySelector('.cart-checkout').style.position = 'unset'
  //               let aTag = $('.cart-checkout')
  //               setTimeout(() => {
  //                 $('#cart-right-side').scrollTop($('.cart-content').height())
  //               }, 500)
  //             }
  //           } else {
  //             document.querySelector('.cart-checkout').style.position = 'fixed'
  //           }
  //         } else {
  //           document.querySelector('.cart-checkout').style.position = 'fixed'
  //         }
  //       }
  //     }

  //   })
  // }

  // render cart on load
  setTimeout(() => {
    getCartContent()

    // Listener for change in the discount code div
    // let whatToObserve = { childList: true, attributes: true, subtree: true, attributeOldValue: true, attributeFilter: ['class', 'style'] }
    let whatToObserve = { childList: true, subtree: true }
    let mutationObserver = new MutationObserver(function (mutationRecords) {
      $.each(mutationRecords, function (index, mutationRecord) {
        if (mutationRecord.type === 'childList') {
          if (mutationRecord.addedNodes.length > 0) {
            //DOM node added, do something
            watchDiscount()
          }
          else if (mutationRecord.removedNodes.length > 0) {
            //DOM node removed, do something
            watchDiscount()
          }
        }
      })
    });
    if (document.getElementById('discount-container')) {
      mutationObserver.observe(document.getElementById('discount-container'), whatToObserve)
    }

  }, 0)

  // allow to check any changeon the sessionStorage variable link to the discount code
  function watchDiscount () {
    let intervalCheck = setInterval(() => {
      let sessionData = sessionStorage.getItem('scDiscountData')
      if (sessionData) {
        sessionData = JSON.parse(sessionData)

        if ((sessionData.stage == 'initial') || (sessionData.stage == 'complete')) {
          clearInterval(intervalCheck)
          checkDiscount()
        }
      }
    },500)
  }

  // check cookie to display newsletter popup
  setTimeout(() => {
    checkPopoupCookie()
  }, 3000)

  // wait for search app to render and display the products to avoid display layout misaligned
  setTimeout(() => {
    let aux = document.getElementById('gf-products')
    if (aux) {
      aux.style.cssText = 'display: flex !important'
      aux.style.minHeight = '350px'
      aux.style.margin = 'auto'
    }

    // Override the jdgm.badge function to prevent rendering the badge.
    if (jdgm) {
      jdgm.badge = function () { }
    }
  }, 1000)

  // Close menu when pressing ESC.
  $(document).on('keydown', function (e) {
    if (e.keyCode === 27) {
      e.preventDefault()
      e.stopPropagation()
      closeSearch()
    }
  })

  $('.btn-close, .screen-overlay').click(function (e) {
    $('body').removeClass('body-no-scroll')
    $('.screen-overlay').removeClass('show')
    $('.offcanvas').removeClass('show')
    $('body').removeClass('offcanvas-active')
    $('html').removeClass('html-full-height')

    let searchHeader = document.querySelector('#search_results_count')
    if (searchHeader) searchHeader.style.display = 'none'
    if (searchHeader && searchHeader.innerHTML) searchHeader.innerHTML = ''
    window.scrollTo(0, lastScrollPosition)
  })

  // close search
  $('.screen-overlay-search, .search-drawer__close').click(function (e) {
    closeSearch()
  })

  // for search top - check if there is not results, display top searched
  $('#search-drawer-top')
    .on('keyup', function (event) {
      let aux_input = document.getElementById('search-drawer-top')
      last_search = aux_input.value
      if (last_search.length >= 2) {
        setTimeout(() => {
          getResultsCount(document.getElementById('search-drawer-top').value)
        },500)
        document.querySelector('.top-searched').style.display = 'none'
        document.querySelector('.instant-search-results').style.display = ''
        $('.search-drawer__container').css('border-bottom', '1px solid transparent')
      } else {
        let searchHeader = document.querySelector('#search_results_count')
        if (searchHeader && searchHeader.innerHTML) searchHeader.innerHTML = ''

        document.querySelector('.top-searched').style.display = ''
        document.querySelector('.instant-search-results').style.display = 'none'
        document.querySelector('.instant-search-results__view-all').style.opacity = '0'
        $('.search-drawer__container').css('border-bottom', '1px solid rgba(204, 204, 204, 0.45)')
      }
    })
    .on('blur', function (event) {
      event.preventDefault()
      document.getElementById('search-drawer-top').value = last_search
      if (last_search.length >= 2) {
        // document.querySelector('.ui-menu').style.setProperty('visibility', 'visible','important')
      } else {
        // document.querySelector('.top-searched > span').style.opacity = '1'
        // document.querySelector('.top-searched > div').style.opacity = '1'
        // document.querySelector('.ui-menu').style.setProperty('visibility', 'hidden','important')
      }
    })
    .on('focusout', function (event) {
      event.preventDefault()
      document.getElementById('search-drawer-top').value = last_search
      if (last_search.length >= 2) {
        // document.querySelector('.ui-menu').style.setProperty('visibility', 'visible' , 'important')
      } else {
        // document.querySelector('.top-searched > span').style.opacity = '1'
        // document.querySelector('.top-searched > div').style.opacity = '1'
        // document.querySelector('.ui-menu').style.setProperty('visibility', 'hidden', 'important')
      }
    })

  // $('.ui-menu')
  //   .on('click', function (event) {
  //     event.preventDefault()
  //     event.stopPropagation()
  //     document.getElementById('search-drawer-top').value = last_search
  //     if (last_search.length >= 2) {
  //       // document.querySelector('.ui-menu').style.setProperty('visibility', 'visible', 'important')
  //     } else {
  //       // document.querySelector('.top-searched > span').style.opacity = '1'
  //       // document.querySelector('.top-searched > div').style.opacity = '1'
  //       // document.querySelector('.ui-menu').style.setProperty('visibility', 'hidden','important')
  //     }
  //   })
})


function checkFreeGift(){

  fetch('/cart.js', {
    method: 'GET'
  })
    .then((response) => {
      response.json()
        .then((result) => {

          let freeProductLimit = parseInt($("#framar_sticker_in_cents").val());
          let bagProductLimit = parseInt($("#framar_bag_in_cents").val());
          
          let products = result.items;
          let freeProductAdded = false;
          let bagProductAdded = false;
          for (let i = 0; i < products.length; i++) {
            if(products[i].id == freeProductId){
              freeProductAdded = true;
            }
            if(products[i].id == bagProductId){
              bagProductAdded = true;
            }
          }
          
          // remove free product if total less then limit
          // if(result.total_price < freeProductLimit && freeProductAdded == true){
          //   jQuery.post('/cart/change.js', { quantity: 0, id: freeProductId }).always(function(){
          //     getCartContent();
          //   });
          // }

          // remove bag product if total less then limit
          // if(result.total_price < bagProductLimit && bagProductAdded == true){
          //   jQuery.post('/cart/change.js', { quantity: 0, id: bagProductId }).always(function(){
          //     getCartContent();
          //   });
          // }

          var gift_manually_removed = $.cookie("gift-removed");
          var bag_manually_removed = $.cookie("bag-removed");
          if(products.length == 0){
            // reset gift cokkie if cart become empty
            $.cookie("gift-removed", 0, { path : "/" });
            $.cookie("bag-removed", 0, { path : "/" });
          }
          
          if(result.total_price >= freeProductLimit && freeProductAdded == false && gift_manually_removed != 1 && freeProductEnable == true){
            // added if elegibal
            let formData = {
              'items': [{
                'id': freeProductId,
                'quantity': 1
              }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              //window.location.reload(true);
              //return response.json();
              getCartContent();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }

          if(result.total_price >= bagProductLimit && bagProductAdded == false && bag_manually_removed != 1 && bagProductEnable == true){
            // added if elegibal
            let formData = {
  				'items': [{
    				'id': bagProductId,
    				'quantity': 1
    				}]
  			};
  			fetch(window.Shopify.routes.root + 'cart/add.js', {
    				method: 'POST',
    				headers: {
      				'Content-Type': 'application/json'
    				},
    				body: JSON.stringify(formData)
  			})
  			.then(response => {
                	//window.location.reload(true);
                //return response.json();
                
                getCartContent();
                    
  			})
  			.catch((error) => {
    				console.error('Error:', error);
  			});
          }
          
        })
    });
}

//23-12-2022
$(document).ready(function(){
  $('.accordion-list-afterpay > li > .answer').hide();
  $('.accordion-list-afterpay > li').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list-afterpay > li.active .answer").slideUp();
      $(".accordion-list-afterpay > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
});
